<template>
    <div>
        <Banner :banners="banners" show-overlay class="green"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper green">
            <h2 class="title text-center">
                QRCode網址列表
            </h2>

            <ul>
                <li v-for="q in qrcodesList" :key="q.id" class="mb-3">
                    {{ q.name }}
                    <br />
                   <span class="text-sm"> {{ getQRCodeUrl(q.id) }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { mapState } from 'vuex';
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
        };
    },

    mounted() {},
    computed: {
        ...mapState('dataList', ['qrcodesList']),
    },
    methods: {
        getQRCodeUrl(id) {
            return `${process.env.VUE_APP_API}/Qrcode/AddReach?id=${id}&redirectUrl=<欲跳轉的網址>`;
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
